import { FaturasModel } from "model/api/gestao/fatura/faturas-model";
import { EnumTipoFatura } from "model/enums/enum-tipo-fatura";
import { CardNaoEncontrado } from "views/components/cards";
import { CardFatura } from "views/components/cards/card-fatura";
import { InformacaoIcon } from "views/components/icons";

export interface FaturasGridProps {
  list: Array<FaturasModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (id: string, tipo?: EnumTipoFatura) => any;
  onCardChecked: (id: string) => any;
  label?: string;
}

export const FaturaListData = (props: FaturasGridProps) => {

  const onCardSelected = (id: string, tipo?: EnumTipoFatura) => {
    props.onCardSelected(id, tipo);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem={`Nenhuma ${props.label || 'Fatura'} Encontrada.`}
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props.list.length > 0 &&
        props.list.map((fatura, index) => {
          return (
            <CardFatura
              selected={
                props.selectedList.filter((item) => item === fatura.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={fatura}
              key={index}
            />
          );
        })}
    </>
  );
};
